<template>
  <table class="add-tree-block">
    <thead>
      <tr>
        <th>Порода</th>
        <th>Ярус</th>
        <th>Поколение</th>
        <th v-if="selectedLpo && selectedLpo.inspection_type_id === '2'">
          Площадь сечения, кв.м
        </th>
        <th v-else>Диаметр, см</th>
        <th>Категория состояния</th>
        <!-- <th>Причина неликвидности</th> -->
        <th>Повреждения</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style="display: flex">
          <p-dropdown
            v-model="selected.species"
            :options="speciesList"
            optionLabel="name"
            dataKey="id"
            class="p-inputtext-sm"
          />
          <p-button
            @click="openAddTaxSpecies"
            icon="fa fa-plus"
            class="p-button-sm"
          />
          <AddTaxSpeciesBlock
            v-if="addTaxSpeciesIsOpen"
            @close="closeAddTaxSpecies"
          />
        </td>
        <td>
          <p-dropdown
            v-model="selected.layer"
            :options="layerList"
            class="p-inputtext-sm"
            optionLabel="name" 
            optionValue="value"
          />
        </td>
        <td>
          <p-dropdown
            v-model="selected.gen"
            :options="genList"
            class="p-inputtext-sm"
          />
        </td>
        <td v-if="selectedLpo && selectedLpo.inspection_type_id === '2'">
          <p-dropdown
            v-model="selected.s_05"
            :options="info_s_05"
            class="p-inputtext-sm"
          />
        </td>
        <td v-else>
          <p-input-number
            v-model="selected.d"
            :min="1"
            :max="1000"
            :step="1"
            showButtons
            class="p-inputtext-sm"
          />
        </td>
        <td>
          <p-dropdown
            v-model="selected.state_cat"
            :options="info_state_cat"
            optionLabel="name"
            dataKey="id"
            class="p-inputtext-sm"
          />
        </td>
        <!-- <td>
          <p-dropdown
            v-model='selected.nonliquid_reason'
            :options='info_nonliquid_reasons'
            optionLabel='name'
            dataKey='id'
            showClear
            class='p-inputtext-sm'
          />
        </td> -->
        <td>
          <p-input-text
            v-model="damageStr"
            @focus="openDamagePanel"
            :disabled="
              !this.selected.species ||
                !this.selected.state_cat ||
                this.selected.state_cat.id === '1'
            "
            class="p-inputtext-sm"
          />
          <p-overlay-panel
            ref="damages-panel"
            appendTo="body"
            :dismissable="false"
            showCloseIcon
          >
            <DamageBlock
              :adding-tree="selected"
              :groupedDamageList="groupedDamageList"
              @damage-select="onDamageSelect"
              @symptom-select="onSymptomSelect"
              @add-damage="onAddDamage"
              @remove-damage="onRemoveDamage"
            />
          </p-overlay-panel>
        </td>
      </tr>
      <tr>
        <td>
            <div class="nonliquid-block__checkbox-container">
              <custom-p-checkbox
                v-model="selected.is_liquid"
                label="Дерево ликвидно"
              />
            </div>
        </td>
        <td>
            <div v-if="!selected.is_liquid" class="nonliquid-reason-block">
              <span class="label">Причина неликвидности</span>
              <custom-p-select
                v-model="selected.nonliquid_reason"
                :options="info_nonliquid_reasons"
              />
            </div>
        </td>
      </tr>
      <tr>
        <td colspan="20">
          <div class="low-row">
            <div class="low-row__left">
              <span>Кол-во деревьев</span>
              <p-input-number
                v-model="treeAmount"
                showButtons
                :min="1"
                :max="10000"
                :step="1"
                class="p-inputtext-sm"
              />
            </div>
            <div class="low-row__right">
              <p-button :disabled="!selected.is_liquid && selected.nonliquid_reason == null || 
                        (selectedLpo && selectedLpo.inspection_type_id !== '2' && selected.d == null) || 
                          selected.species == null || selected.gen == null || selected.layer == null"
                label="Сохранить"
                @click="saveTree"
                class="p-button-sm"
              />
              <p-button
                label="Закрыть"
                @click="closeAddBlock"
                class="p-button-sm"
              />
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapState, mapActions } from "vuex";
import processJSON from "@/lib/processJSON";
import AddTaxSpeciesBlock from "./Recount__treesAddTaxSpecies";
import DamageBlock from "./RecountTreesDamagePicker";

const info_s_05 = [0.5, 1];

export default {
  name: "TreesAddRow",

  components: {
    DamageBlock,
    AddTaxSpeciesBlock,
  },

  props: {
    selectedPlot: Object,
  },

  data: () => ({
    selected: {
      species: null,
      layer: null,
      gen: null,
      s_05: 1,
      d: null,
      state_cat: null,
      is_liquid: true,
      nonliquid_reason: null,
      damages: [],
    },

    treeAmount: 1,
    addTaxSpeciesIsOpen: false,

    info_s_05,
  }),

  computed: {
    selectedLpo() {
      return this.$store.state.selectedLpo.lpo;
    },

    groupedDamageList() {
      const damagesObj = {};

      for (const damage of this.selected.damages) {
        if (!(damage.reason.id in damagesObj)) {
          damagesObj[damage.reason.id] = [];
        }
        damagesObj[damage.reason.id].push(damage);
      }

      return damagesObj;
    },

    damageStr: {
      get() {
        const damageStrList = [];

        for (const reason_id of Object.keys(this.groupedDamageList)) {
          const symptomList = [];

          for (const damage of this.groupedDamageList[reason_id]) {
            symptomList.push(damage.symptom.id);
          }

          const damageStrTemp = `${reason_id}(${symptomList.join(", ")})`;
          damageStrList.push(damageStrTemp);
        }

        return damageStrList.join(" ");
      },
      set() {},
    },

    ...mapState({
      info_state_cat: (state) => state.catalogs.info_state_cat,
      info_nonliquid_reasons: (state) => state.catalogs.info_nonliquid_reasons,
    }),

    ...mapState("common", {
      layerList: (state) => state.layerList,
      genList: (state) => state.genList,
    }),

    ...mapState("recount", {
      speciesList: (state) => state.trees.speciesList,
    }),

    ...mapState("selectedLpo/recount", {
      treeList: (state) => state["treeList"],
      plotList: (state) => state["plotList"]
    }),
  },

  methods: {
    ...mapActions("selectedLpo/recount", [
      "getTreeList",
      "getMainDamageReasonList",
      "getSelectedMainDamageReasonList"
    ]),
    closeAddBlock() {
      this.$emit("close");
    },

    openAddTaxSpecies() {
      this.addTaxSpeciesIsOpen = true;
    },

    closeAddTaxSpecies() {
      this.addTaxSpeciesIsOpen = false;
    },

    onAddDamage(damage) {
      const findedIndex = this.selected.damages.findIndex((d) => {
        return damage.reason.id === d.reason.id;
      });

      if (findedIndex !== -1) {
        this.$toast.add({
          severity: "warn",
          detail: "Данное повреждение уже добавлено",
          life: 10000,
        });
        return;
      }
      
      const damages = damage.symptoms.map((symptom) => {
        return {
          reason: damage.reason,
          symptom: symptom,
        };
      });

      for (const d of damages) {
        this.selected.damages.push(d);
      }
      this.closeDamagesPanel() // anton
    },

    onRemoveDamage(reason_id) {
      // this.$emit('remove-damage', reason_id);

      let findedIndex = this.selected.damages.findIndex((damage) => {
        return +damage.reason.id === +reason_id;
      });

      console.log("findedIndex", findedIndex);
      console.log("damages", this.selected.damages);

      while (findedIndex !== -1) {
        this.selected.damages.splice(findedIndex, 1);

        findedIndex = this.selected.damages.findIndex((damage) => {
          return +damage.reason.id === +reason_id;
        });
      }
    },

    speciesIdError() {
      this.$toast.add({
        severity: "danger",
        detail: "no species id",
        life: 10000,
      });
    },

    openDamagePanel(event) {
      if (!this.selected.species) {
        this.$toast.add({
          severity: "warn",
          detail: "Выберите породу",
          life: 10000,
        });
        return;
      }

      if (!this.selected.state_cat || this.selected.state_cat.id === "1") {
        this.$toast.add({
          severity: "warn",
          detail: "Выберите категорию состояния",
          life: 10000,
        });
        return;
      }

      this.$refs["damages-panel"].show(event);
    },
    closeDamagesPanel() {
      this.$refs["damages-panel"].hide();
    },

    onDamageSelect(selectedDamage) {
      const findedIndex = this.selected.damages.findIndex((damage) => {
        return (
          damage.reason.id === selectedDamage.reason.id &&
          damage.symptom.id === selectedDamage.symptom.id
        );
      });

      if (findedIndex === -1) {
        this.selected.damages.push(selectedDamage);
      } else {
        this.selected.damages.splice(findedIndex, 1);
      }
    },

    onSymptomSelect(selectedSymptom) {},

    saveTree() {
      // console.log(JSON.stringify(this.selected, null, 2));
      // console.log('treeList: ', this.treeList);
      // console.log('selectedPlot: ', this.selectedPlot);
      // return;
      const plot_id = this.selectedPlot.id;
      const count = this.treeAmount;
      const tree = this.selected;
      // const damages = tree.damages;
      console.log('tree = ', this.selected);
     
      const tabDamages = [];
      for (const damage of tree.damages) {
        const temp = {
          tab_name: "data_lpo_inventory_damages",
          f_v: {
            reason_id: damage.reason.id,
            symptom_id: damage.symptom.id,
          },
        };
        tabDamages.push(temp);
      }

      let num = this.treeList[plot_id].length + 1;

      const tab = [];

      // return;
      for (let i = 0; i < count; ++i) {
        const temp = {
          tab_name: "data_lpo_inventory",
          f_v: {
            parent_id: plot_id,
            tree_num: num++,
            layer: tree.layer,
            gen: tree.gen,
            species_id: tree.species.id,
            d: tree.d,
            s_05: tree.s_05,
            state_cat_id: tree.state_cat.id,
            is_liquid: tree.is_liquid,
            nonliquid_reason_id: tree.nonliquid_reason
              ? tree.nonliquid_reason.id
              : null,
          },
          tab: tabDamages,
        };
        tab.push(temp);
      }

      const json_obj = [
        {
          i: {
            tab: tab,
          },
        },
      ];

      const json_str = JSON.stringify(json_obj);
      // console.log(json_str);
      // return;
      let _this = this
      return processJSON(json_str).then((res) => {
        _this.selected.is_liquid = true;
        _this.selected.nonliquid_reason = null; 
        // Обновление списка главных причин
        this.getMainDamageReasonList()
          .then(() => {
            this.getSelectedMainDamageReasonList()
          });

        return this.getTreeList(this.plotList)
          .then(() => {
            this.treeAmount = 1;
            this.selected.damages = [];
            this.$emit("added");
          });
      });
    },
  },

  created() {
    this.$store.dispatch("recount/fetchSpeciesList");
    this.$store
      .dispatch("loadCatalogs", ["info_state_cat", "info_nonliquid_reasons"])
      .then((res) => {
        this.selected.state_cat = this.info_state_cat.length
          ? this.info_state_cat[0]
          : null;
      });

    //this.selected.layer = this.layerList[0];
    this.selected.gen = this.genList[0];
  },
};
</script>

<style scoped>
.add-tree-block {
  width: 100%;
}

.p-inputtext,
.p-inputnumber,
.p-dropdown {
  width: 100%;
}

.low-row {
  display: flex;
  margin-top: 1rem;
  margin-bottom: 2rem;
  justify-content: flex-start;
}

.low-row .p-inputnumber {
  width: 100px;
}

.low-row__left {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.low-row__right {
  display: flex;
  margin-left: 20px;
}
.low-row__right button {
  margin-right: 5px;
}
.nonliquid-block__checkbox-container {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
